import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { CommonService } from '../../../../services/common/common.service';
import { PushMessagesDataService, PushMessagesColumnsService } from '../../../services';
import { PushMessage, PushMessagesResult } from '../../../interfaces';

@Component({
  selector: 'app-push-message-form',
  templateUrl: './push-message-form.component.html',
  styleUrls: ['./push-message-form.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class PushMessageFormComponent implements OnInit, OnDestroy, AfterViewInit {

  public pushMessage: PushMessage = {};
  public pushMessageForm: FormGroup = new FormGroup({});
  public pushMessages: PushMessage[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public redirect = true;
  public disableSubmit = false;
  public enableFormAlert = true;


  constructor(
    private translate: TranslateService,
    public common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private pushMessagesDataService: PushMessagesDataService,
    public pushMessagesColumnsService: PushMessagesColumnsService,
  ) {
  }

  ngOnInit(): void {
    console.log('ngOnInit', 'PushMessageFormComponent');
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Push Message - Edit');
        this.getPushMessage(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.pushMessage !== 'undefined') {
      this.pushMessage = this.dynamicDialogConfig.data.pushMessage;
    }
    if (typeof this.pushMessage.id === 'undefined' || this.pushMessage.id === null) {
      this.pushMessage.id = null;
      this.pushMessage.delivery = moment().set({minute: 0, second: 0, millisecond: 0}).format('YYYY-MM-DD\THH:mm:ssZ');
    }
    this.getPushMessages();
    this.prepareFrom();
  }

  ngOnDestroy(): void {
    console.log('ngOnDestroy', 'PushMessageFormComponent');
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit', 'PushMessageFormComponent');
  }

  getPushMessage(id: number): void {
    this.isLoading = true;
    this.pushMessagesDataService.getPushMessage(id).subscribe((response: PushMessage|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.pushMessage = response;
        this.prepareFrom();
      }
    });
  }

  getPushMessages(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.pushMessages !== 'undefined' && this.dynamicDialogConfig.data.pushMessages.length > 0) {
      this.pushMessages = this.dynamicDialogConfig.data.pushMessages;
      return;
    }
    this.pushMessagesDataService.getPushMessages(this.parameters).subscribe((response: PushMessagesResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.pushMessages = response.results;
      }
    });
  }

  prepareFrom(): void {
    this.pushMessage.delivery = moment(this.pushMessage.delivery).toDate();
    this.pushMessageForm = new FormGroup({
      id: new FormControl(this.pushMessage.id, []),
      pushDevice: new FormControl((typeof this.pushMessage.pushDevice === 'number') ? this.pushMessage.pushDevice : this.pushMessage.pushDevice?.id, [Validators.required, ]),
      pushNotification: new FormControl((typeof this.pushMessage.pushNotification === 'number') ? this.pushMessage.pushNotification : this.pushMessage.pushNotification?.id, [Validators.required, ]),
      delivery: new FormControl(this.pushMessage.delivery, []),
      languageCode: new FormControl(this.pushMessage.languageCode, []),
      sendingStatus: new FormControl(this.pushMessage.sendingStatus, [Validators.required, ]),
      response: new FormControl(this.pushMessage.response, []),
    });
  }

  list() {
    this.router.navigate(['/push-messages']);
  }

  showErrors() {
      this.showErrors();
      const invalidFields: string[] = [];
      Object.keys(this.pushMessageForm.controls).forEach((field: any) => {
        const control = this.pushMessageForm.get(field);
        if (control !== null) {
          control.markAsTouched({ onlySelf: true });
          if (control.invalid) {
            invalidFields.push(field);
          }
        }
      });
  }

  submitForm(redirect: boolean) {
    this.redirect = redirect;
    if (!this.pushMessageForm.valid) {
      this.showErrors();
    } else {
      this.saveData(redirect);
    }
  }

  saveData(redirect: boolean) {
    this.pushMessage = this.pushMessageForm.value;
    this.disableSubmit = true;
    console.log('pushMessage', this.pushMessage);
    if (typeof this.pushMessage.id !== 'undefined' && this.pushMessage.id !== null) {
      this.add(redirect);
    } else {
      this.update(redirect);
    }
    return false;
  }

  add(redirect: boolean) {
    this.pushMessagesDataService.updatePushMessage(this.pushMessage).subscribe((data: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('PUSHMESSAGEUPDATED')});
      if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
        this.dynamicDialogRef.close({refresh: true});
      } else if (redirect) {
        this.list();
      }
    }, (error: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('PUSHMESSAGENOTUPDATED') + ' ' + error.message});
      console.warn(error);
    });
  }

  update(redirect: boolean) {
    this.pushMessagesDataService.addPushMessage(this.pushMessage).subscribe((data: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('PUSHMESSAGECREATED')});
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({refresh: true});
        } else if (redirect) {
          this.list();
        }
      }, (error: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('PUSHMESSAGENOTCREATED') + ' ' + error.message});
        console.warn(error);
    });
  }

}

@Component({
  selector: 'app-push-message-form',
  templateUrl: './push-message-form.component.html',
  styleUrls: ['./push-message-form.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogPushMessageFormComponent extends PushMessageFormComponent {
}

